import { render, staticRenderFns } from "./PackageFormView.vue?vue&type=template&id=401e576f&scoped=true"
import script from "./PackageFormView.vue?vue&type=script&lang=js"
export * from "./PackageFormView.vue?vue&type=script&lang=js"
import style0 from "./PackageFormView.vue?vue&type=style&index=0&id=401e576f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401e576f",
  null
  
)

export default component.exports